import { IconButton, Tooltip } from '@mui/material';
import { useSelector } from 'react-redux';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { selectors as growerSelectors } from '../../store/dux/grower-dux';
import { selectors as environmentSelectors } from '../../store/dux/environment-dux';
import { usePermission } from '../../hooks/use-permission';

export function FarmgateLink({ isVisible, ...props }) {
  const growerId = useSelector(growerSelectors.selectedId);
  const farmgateUrl = useSelector(environmentSelectors.farmgateUrl);
  const canViewFg = usePermission('VIEW_FARMGATE');
  const shouldShow = isVisible && growerId && canViewFg;

  return (
    shouldShow && (
      <Tooltip title="Go to FarmGate">
        <IconButton
          color="inherit"
          data-testid="farmgate-link"
          target="_blank"
          href={`${farmgateUrl}/operations-redirect/${growerId}`}
          {...props}
        >
          <OpenInNewIcon />
        </IconButton>
      </Tooltip>
    )
  );
}
